export { GoogleAnalyticsEvent, GoogleAnalyticsEventTypes, GoogleAnalyticsPageview } from '@evenfinancial/even-ts-static'
export type GtagClient = Gtag.Gtag
export type GtagClientGetter = () => GtagClient | undefined

export const GTAG_UNIQUE_EVENT_ID_KEY = 'gtm.uniqueEventId'
export interface GtagCapturedEvent {
  [GTAG_UNIQUE_EVENT_ID_KEY]?: number
}

export type UniversalAnalyticsId = `UA-${number}-${number}`
export type GtagId = `GTM-${string}`

export enum GtagCommand {
  CONFIG = 'config',
  EVENT = 'event',
}

export type GtagEventName = Gtag.EventNames
export type GtagEventParams = Gtag.ControlParams | Gtag.EventParams | Gtag.CustomParams

export interface GtagOptimizeConfig {
  optimize_id?: GtagId
}

export interface GtagConfig extends Gtag.ConfigParams, GtagOptimizeConfig {}

export type DataLayerEntry =
  | { event?: 'string'; EVEN_COHORT?: 'string' }
  | [GtagCommand.CONFIG, UniversalAnalyticsId, GtagConfig]
  | [GtagCommand.EVENT, GtagEventName, GtagEventParams]

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DataLayer extends Array<DataLayerEntry> {}
export type DataLayerGetter = () => DataLayer | undefined

export enum GoogleAnalyticsEventKey {
  ACTION = 'action',
  CATEGORY = 'category',
  FIELDS = 'fields',
  LABEL = 'label',
  PATH = 'path',
  TITLE = 'title',
}
export enum GtagEventKey {
  CATEGORY = 'event_category',
  LABEL = 'event_label',
  PATH = 'page_path',
  TITLE = 'page_title',
}

declare global {
  interface Window {
    dataLayer: DataLayer
  }
}
